






















































































































import { Component, Prop, Ref, Vue, Watch, PropSync } from 'vue-property-decorator';
import CardTitle from '@/components/common/CardTitle.vue';
import BarChart from '@/components/chart/BarChart.vue';
import RadialBarChart from '@/components/chart/RadialBarChart.vue';
import DonutChart from '@/components/chart/DonutChart.vue';
import { CHART_TYPES, CHART_TYPE_NAMES } from '@/utils/ChartTypes';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import Modelling from '@/store/modules/Modelling';
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import Choices from '@/store/modules/Choices';
import Viewpoints from '@/store/modules/Viewpoints';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Scoring from '@/store/modules/Scoring';
import ScoringKeys from '@/store/modules/ScoringKeys';

const scoringKeysModule = getModule(ScoringKeys);
const workspaceOptions = getModule(WorkspaceOptions);
const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const viewpointModule = getModule(Viewpoints);
const choiceModule = getModule(Choices);



@Component({
    name: 'ChoiceScoreChart',
    components: {
        RadialBarChart,
        DonutChart
    },
})
export default class ChoiceScoreRadialChart extends Vue {
    @Prop({ default: '', type: String })
    factorId!: string;
    groupName: string;

    private items = CHART_TYPES;
    private CHART_TYPE_NAMES = CHART_TYPE_NAMES;
    private isLoading = false;
    private tooltipShow = false;
    private open = false;
    private task: any;



    private chartData = {
        data: {
            series: [],
        },
        title: '',
        xaxis: {
            categories: [],
        },
    };
    private radial = {
        data: {
            series:[],
        },
        title: {
            text: '',
        },
       labels: [],
    };
    private summaryData = {}

    private cancelTask() {
        clearTimeout(this.task);
    }

    // private chartDataDelay() {
    //     this.task = setTimeout(() => {this.getChartData() }, 800);
    // }

    get chartTitle(){
        console.log("chart title is:",this.chartData.title)
        return this.chartData.title;
    }

    get barChartData() {
        return this.chartData;
    }

    get isDonutChart() {
        console.log("is donutchart", workspaceOptions.isDonutChart)
        return workspaceOptions.isDonutChart;
    }

    set isDonutChart(isDonut: boolean) {
        workspaceOptions.setIsDonutChart(isDonut);
    }

     get radialChartData(){
        return this.summaryData;
    }
     private chartDataDelay() {
        this.task = setTimeout(() => {this.getChartData() }, 800);
    }


    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get decisionId() {
        return decisionsModule.selectedDecisionId;
    }

    get activeViewpointId() {
        return viewpointModule.activeViewpointId;
    }
    //TOdo GET viewpoint name for labelling
    get activeViewpointName() {
        return viewpointModule.activeViewpointId;
    }

    get isBarChartHorizontal() {
        return workspaceOptions.isBarChartHorizontal;
    }

    set isBarChartHorizontal(isHorizontal: boolean) {
        workspaceOptions.setIsBarChartHorizontal(isHorizontal);
    }

    get selectedChoices() {
        return choiceModule.unfilteredChoicesList;
    }

    get viewpointScoringKeyDefinitions() {
        return scoringKeysModule.viewpointScoringKeyDefinitions;
    }


    

    private async getChartData() {
        try {
            if (this.factorId !== '') {
                this.isLoading = true;
                const factor = this.factors[this.factorId];
                const scoreskeys = this.viewpointScoringKeyDefinitions
                const summaryData = await getModule(Scoring).getStackedSummaryChartDataChoiceTab({scoreskeys: scoreskeys, decisionId: this.decisionId, viewpointId: this.activeViewpointId, factorIds: factor.childrenIds, factorParentId: factor.id});   // await VIEWPOINT_API.generateStackedBarChart(this.decisionId, [this.activeViewpointId], factor.childrenIds)
                console.log("Inside getCharData", summaryData)
                this.summaryData = summaryData
                
                
                this.isLoading = false;
            }
        } catch (error) {
            console.log(error);
        }
    }
}
    






